import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import columns from './columns'
import { observer, inject } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  render() {
    return (
      <SearchBarTable
        store={this.props.store}
        columns={columns}
        style={{ wordBreak: 'break-all' }}
      />
    )
  }
}
